<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          NO: {{ formData.userReimbursementNo || 'New' }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <b-badge
          style="font-size: 12px"
          :variant="
            formData.userReimbursementStatus === 'Y'
              ? 'success'
              : formData.userReimbursementStatus === 'S'
              ? 'warning'
              : formData.userReimbursementStatus === 'D' ||
                formData.userReimbursementStatus === 'R'
              ? 'danger'
              : 'primary'
          "
        >
          {{ formData.v_userReimbursementStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify: {{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_salesPersonCode') || '业务人员'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              url="/master/common/dict/baseUserSelect"
              :selectedLabel.sync="formData.salesPersonName"
              :placeholder="
                $l('tips_select_salesPersonCode') || '请选择业务人员'
              "
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_requestDate') || '申请日期'"
            prop="requestDate"
          >
            <el-date-picker
              v-model="formData.requestDate"
              :picker-options="requestDatePicker"
              :placeholder="$l('tips_select_requestDate') || '请选择申请日期'"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="16">
          <el-form-item
            :label="$l('form_label_expensePayerName') || '申请人公司'"
            prop="expensePayerCode"
          >
            <dict-select
              v-model="formData.expensePayerCode"
              url="/master/common/dict/biz"
              :body="expensePayerParams"
              :placeholder="
                $l('tips_select_expensePayerName') || '请选择申请人公司'
              "
              :selectedLabel.sync="formData.expensePayerName"
              filterable
              clearable
              size="mini"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_substituteInvoice') || '代用发票'"
          >
            <el-select
              v-model="formData.substituteInvoice"
              :placeholder="
                $l('tips_select_substituteInvoice') || '请选择代用发票'
              "
              style="width: 100%"
              filterable
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_forwardGeneralManager') || '转送总经理'"
          >
            <el-select
              v-model="formData.forwardGeneralManager"
              :placeholder="
                $l('tips_select_forwardGeneralManager') || '请选择转送总经理'
              "
              style="width: 100%"
              filterable
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_businessConsumption') || '业务消费'"
          >
            <el-select
              v-model="formData.businessConsumption"
              :placeholder="
                $l('tips_select_businessConsumption') || '请选择业务消费'
              "
              style="width: 100%"
              filterable
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_otherSet') || '420'">
            <el-select
              v-model="formData.otherSet"
              :placeholder="$l('tips_select_otherSet') || '请选择420'"
              style="width: 100%"
              filterable
            >
              <el-option
                v-for="item in selectOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_costCategory') || '费用大类'"
            prop="costCategory"
          >
            <dict-select
              v-model="formData.costCategory"
              url="/master/common/dict/biz"
              :body="costCategoryParams"
              :placeholder="$l('tips_select_costCategory') || '请选择费用大类'"
              filterable
              size="mini"
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_paymentMethod') || '付款方式'"
            prop="paymentMethod"
          >
            <dict-select
              v-model="formData.paymentMethod"
              url="/master/common/dict/biz"
              :body="paymentMethodParams"
              :placeholder="$l('tips_select_paymentMethod') || '请选择付款方式'"
              size="mini"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_currencyAmount') || '费用合计'">
            <el-input v-model="v_currencyAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_cashAdvances') || '预支金额'">
            <el-input-number
              v-model="formData.cashAdvances"
              :placeholder="
                $l('tips_input_paymentMethod') || '请输入预支金额...'
              "
              :precision="2"
              :step="0.01"
              :min="0"
              :max="1000000000"
              style="width: 100%"
              controls-position="right"
              v-el-inputnumber-default0
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              :placeholder="$l('tips_select_currencyUnit') || '请选择货币单位'"
              size="mini"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_remark') || '发票费用类型'"
            prop="remark"
          >
            <el-input
              v-model="formData.remark"
              :placeholder="$l('tips_input_remark') || '请输入发票费用类型...'"
              maxlength="50"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_description') || '情况说明'"
            prop="description"
          >
            <el-input
              v-model="formData.description"
              :placeholder="$l('tips_input_description') || '请输入情况说明...'"
              type="textarea"
              :rows="5"
              maxlength="200"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <ItemTable
          ref="itemTable"
          :disabled="disabled"
          :userReimbursementCode="userReimbursementCode"
          @updateTotAmount="(e) => (formData.currencyAmount = e)"
          :depCode="salesPersonInfo.depCode"
          :orgDepFullName="salesPersonInfo.orgDepFullName"
          :substituteInvoice="formData.substituteInvoice"
          :salesPersonCode="formData.salesPersonCode"
        />
      </el-row>
      <el-row>
        <DocTable
          ref="docTable"
          :disabled="disabled"
          :userReimbursementCode="userReimbursementCode"
        />
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import ItemTable from '../item-table'
import DocTable from '../doc-table'
import dayjs from 'dayjs'
export default {
  components: { ItemTable, DocTable },
  mixins: [EditLoading],
  props: {
    userReimbursementCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
  },
  data() {
    return {
      requestDatePicker: this.requestDateEnd(),
      expensePayerParams: { dictType: 'expensePayer' },
      payeeTypeParams: { dictType: 'payeeType' },
      currencyUnitParams: { dictType: 'bankAccountKind' },
      paymentMethodParams: { dictType: 'paymentMethod' },
      costCategoryParams: { dictType: 'costCategory' },
      selectOptions: [
        { label: this.$l('YES') || '是', value: '0' },
        { label: this.$l('NO') || '否', value: '1' },
      ],
      formData: {
        requestDate: dayjs(new Date()).format('YYYY-MM-DD'),
        salesPersonCode: '',
        salesPersonName: '',
        payeeType: 'C',
        payeeScmCode: '',
        payeeCustCode: '',
        currencyAmount: 0,
        cashAdvances: 0,
        remark: '',
        description: '',
        substituteInvoice: '1',
        forwardGeneralManager: '1',
        businessConsumption: '1',
        otherSet: '1',
      },
      rules: {
        salesPersonCode: [
          {
            required: true,
            message: this.$l('tips_select_salesPersonCode') || '请选择业务人员',
            trigger: 'change',
          },
        ],
        requestDate: [
          {
            required: true,
            message: this.$l('tips_select_requestDate') || '请选择申请日期',
            trigger: 'change',
          },
        ],
        expensePayerCode: [
          {
            required: true,
            message:
              this.$l('tips_select_expensePayerName') || '请选择申请人公司',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message: this.$l('tips_select_currencyUnit') || '请选择货币单位',
            trigger: 'change',
          },
        ],
        paymentMethod: [
          {
            required: true,
            message: this.$l('tips_select_paymentMethod') || '请选择付款方式',
            trigger: 'change',
          },
        ],
        costCategory: [
          {
            required: true,
            message: this.$l('tips_select_costCategory') || '请选择费用大类',
            trigger: 'change',
          },
        ],
        remark: [
          {
            required: true,
            message: this.$l('tips_input_remark') || '请输入发票费用类型...',
            trigger: 'change',
          },
        ],
        description: [
          {
            required: true,
            message: this.$l('tips_input_description') || '请输入情况说明...',
            trigger: 'change',
          },
        ],
      },
      salesPersonInfo: {},
    }
  },
  computed: {
    v_currencyAmount() {
      const { currencyAmount } = this.formData
      return !currencyAmount ? '0' : currencyAmount.toLocaleString()
    },
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.userReimbursementCode) return
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.salesPersonCode = userCode || ''
        this.formData.salesPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
    // 查询业务人员详情，主要取部门信息作为费用明细的默认分摊部门
    'formData.salesPersonCode': {
      async handler(userCode) {
        if (!userCode) return

        const res = await this.$api.sysUserDetailApi({ userCode })
        if (!res) return
        this.salesPersonInfo = res.body || {}
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    requestDateEnd() {
      return {
        disabledDate(time) {
          //如果结束时间不为空，则小于结束时间
          return new Date().getTime() < time.getTime()
        },
      }
    },
    reload() {
      this.getData()
      this.$refs.itemTable.loadData()
      this.$refs.docTable.loadData()
    },
    getData() {
      if (!this.userReimbursementCode) return
      this.$api
        .userReimbursementDetailApi({
          userReimbursementCode: this.userReimbursementCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await this.formValidate()
      if (!result) return

      const listItem = this.$refs.itemTable.getTableData()
      if (!listItem || !listItem.length) {
        this.$message.warning(
          this.$l('tips_please_add_expense_item') || '请添加费用填报明细'
        )
        return
      }
      for (let i = 0; i < listItem.length; i++) {
        if (
          listItem[i].substituteInvoice === '0' &&
          !listItem[i].originalExpenseType
        ) {
          this.$message.error(
            this.$l('tips_add_original_cost') || '请添加原始费用项目'
          )
          return
        }
      }
      const listDoc = this.$refs.docTable.getTableData() || []
      const invoiceDocList = listDoc.filter((e) => e.payDocFileType == 'A')
      let saveFlag = true
      if (!invoiceDocList || !invoiceDocList.length) {
        saveFlag = false
        await this.$confirm(
          this.$l('tips_no_save_invoice') || '您尚未上传发票，是否保存？',
          this.$l('label_completeDesc') || '确认信息',
          {
            confirmButtonText: this.$l('product_dialog_btn_confirm') || '确定',
            cancelButtonText: this.$l('btn_cancel') || '取消',
            type: 'warning',
          }
        ).then(async () => {
          saveFlag = true
        })
      }
      if (saveFlag) {
        this.loadingOpen()
        this.$api
          .userReimbursementSaveApi({ ...this.formData, listItem, listDoc })
          .then(async (res) => {
            this.loadingClose()
            const { status } = res
            if (status !== 200) {
              this.$message.error(this.$l('tips_save_no') || '保存失败！')
              return
            }
            this.$message({
              showClose: true,
              message: this.$l('tips_save_ok') || '保存成功！',
              type: 'success',
            })
            if (!this.userReimbursementCode) {
              this.closeCurPage()
            } else {
              this.reload()
            }
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('tips_save_no') || '保存失败！')
          })
      }
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.form])
      const itemTableResult = await this.$refs.itemTable.validate()
      return formResult && itemTableResult
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    async getCustData(form) {
      return await this.$api
        .masterCustomerBankListApi(form)
        .then((res) => res.body.data)
        .catch(() => null)
    },
    async getScmData(form) {
      return await this.$api
        .masterScmInfoBankListApi(form)
        .then((res) => res.body.data)
        .catch(() => null)
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
